// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"a2599033","124":"aedab691","320":"97c880ce","373":"ee3f427c","453":"5102a9fe","523":"4aa89c2c","682":"4efb30c2","752":"8f210d8c","892":"afb480b0","905":"e31f5e27","942":"1b0a06df"}[chunkId] + ".chunk.js";
};